import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/section/TitlePage/Titlepage";
import TableInformation from "./Components/TableInformation";
import Button from "./Components/Button";
import Card from "../../../../components/ui/Card/Card";
import { Dropdown } from "../../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../../components/ui/InputDate/InputDate";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "../../../../components/ui/Modal/Modal";
import DataModal from "./Section/LotInventory/DataModal";
import InventoryChangeModal from "./Section/ManualChange/InventoryChangeModal";
import ProductInfo from "./Components/ProductInfo";
import {
  useProductById,
  useStockSummary,
} from "../../../../api/inventory/use-inventory-detail";
import { StockHistoryTable } from "./Section/stock-history-table";
import { useSetState } from "../../../../utils/hooks";
import { QRModal } from "./Section/OtherRelease/QRModal";
import { useProductLotsQnt } from "../../../../api/inventory/use-product-lots-qnt";
import InputSearch from "../../../../components/ui/InputSearch/InputSearch";

const firstRadio = [
  { label: "전체", value: "" },

  { label: "입고 : 스마트팩토리 연동", value: "IN_SMART" },
  { label: "입고 : 수동 등록", value: "IN_MANUAL" },
  { label: "입고 : 교환(재입고)", value: "IN_EXCHANGE" },
  { label: "입고 : 반품(재입고)", value: "IN_RETURN" },
  { label: "입고 : 불량재고 (폐기예정)", value: "IN_DEFECTIVE" },
];

const secondRadio = [
  { label: "조정", value: "ADJUSTMENT_OUT" },
  { label: "출고 : 자동(재고)", value: "OUT_AUTOMATIC_INVENTORY" },
  { label: "출고 : 수동(재고)", value: "OUT_MANUAL_INVENTORY" },
  { label: "출고 : 수동(원데이몰)", value: "OUT_MANUAL_MALL" },
  { label: "출고 : 기타 출고", value: "OUT_OTHER_SHIPMENTS" },
  { label: "출고 : 불량재고(교환)", value: "OUT_DEFECTIVE_STOCK" },
];

const options = [
  { id: 1, name: "기타출고 내역 메모" },
  { id: 2, name: "내역" },
];

const InventoryDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useProductById(id);
  const { data: stockSummary } = useStockSummary(id);
  const { data: productLotQnt } = useProductLotsQnt(id);

  const productData = data?.data;
  // API가 { data: { ... } } 또는 요약 객체를 최상위에 줄 수 있음
  const stockSummaryData = stockSummary?.data ?? stockSummary ?? {};
  const productLotQntData = productLotQnt?.data;
  const currentStockQty = productLotQntData?.currentStockQnt;
  const isEmptyStock = currentStockQty === 0;
  const [discountStartDate, setDiscountStartDate] = useState(null);
  const [discountEndDate, setDiscountEndDate] = useState(null);
  const [selectedDateOption, setSelectedDateOption] = useState();
  const [triggerCloseModal, setTriggerCloseModal] = useState(false);
  const [triggerCloseModalAdjust, setTriggerCloseModalAdjust] = useState(false);
  const [triggerCloseDataModal, setTriggerCloseDataModal] = useState(false);
  const [selectedFilter, setSelectedFilter] = React.useState({});
  const [submittedFilter, setSubmittedFilter] = React.useState({});
  const [searchBy, setSearchBy] = React.useState("name");
  const [searchByValue, setSearchByValue] = React.useState("");
  const [isResetted, setIsResetted] = React.useState(false);
  const [isResetting, setIsResetting] = React.useState(false);
  const [isResettedPage, setIsResettedPage] = React.useState(false);
  const filters = { ...submittedFilter };
  const resettedFilter = {};
  const onChangeSearchBy = (id) => {
    setSearchBy(id);
  };

  const onSubmitFilter = () => {
    setIsResettedPage(true);
    setIsResetted(false);
    setSubmittedFilter({
      ...selectedFilter,
      [searchBy]: searchByValue,
    });
  };

  const onResetFilter = () => {
    setSelectedFilter({});
    setSubmittedFilter({});
    setSearchByValue("");
    setIsResetting(true);
    setIsResetted(true);
  };

  useEffect(() => {
    if (isResetting) {
      setTimeout(() => {
        setIsResetting(false);
      }, 500);
    }
  }, [isResetting]);

  const onChangeSearchByValue = (value) => {
    setSearchByValue(value);
  };

  useEffect(() => {
    if (isResettedPage) {
      setTimeout(() => {
        setIsResettedPage(false);
      }, 200);
    }
  }, [isResettedPage]);

  const [
    triggerCloseDataModalInstruction,
    setTriggerCloseDataModalInstruction,
  ] = useState(false);

  useEffect(() => {
    if (triggerCloseDataModal === true) {
      setTriggerCloseDataModal(false);
    }
  }, [triggerCloseDataModal]);

  useEffect(() => {
    if (triggerCloseDataModalInstruction === true) {
      setTriggerCloseDataModalInstruction(false);
    }
  }, [triggerCloseDataModalInstruction]);

  useEffect(() => {
    if (triggerCloseModalAdjust === true) {
      setTriggerCloseModalAdjust(false);
    }
  }, [triggerCloseModalAdjust]);

  const onCloseModalAdjust = () => {
    setTriggerCloseModalAdjust(true);
  };

  useEffect(() => {
    if (triggerCloseModal === true) {
      setTriggerCloseModal(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerCloseModal]);

  const onCloseModal = () => {
    setTriggerCloseModal(true);
  };

  const onChangeDiscountStartDate = (value) => {
    setDiscountStartDate(value);
    setSelectedFilter({
      ...selectedFilter,
      from: value?.unix(),
    });
  };

  const onChangeDiscountEndDate = (value) => {
    setDiscountEndDate(value);
    setSelectedFilter({
      ...selectedFilter,
      to: value?.unix(),
    });
  };

  const onChangeDateTo = (increment) => {
    if (discountEndDate !== null) {
      setSelectedDateOption(increment);
      if (increment === 1 || increment === 7) {
        const subtracted = discountEndDate.subtract(increment, "day");
        setDiscountStartDate(subtracted);
        setSelectedFilter({
          ...selectedFilter,
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }
      if (increment === 30) {
        const subtracted = discountEndDate.subtract(1, "month");
        setDiscountStartDate(subtracted);
        setSelectedFilter({
          ...selectedFilter,
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }
      if (increment === 90) {
        const subtracted = discountEndDate.subtract(3, "month");
        setDiscountStartDate(subtracted);
        setSelectedFilter({
          ...selectedFilter,
          from: subtracted?.unix(),
          to: discountEndDate?.unix(),
        });
      }
    }
  };

  const handleBack = () => {
    navigate("/product-management/inventory");
  };

  const onSelectRadio = (e) => {
    setSubmittedFilter({
      ...submittedFilter,
      type: e.target.value,
    });
  };

  return (
    <div>
      <TitlePage title={"재고관리 > 재고 상세내역"} />
      <div className="flex items-center justify-between mt-4">
        <p className="text-black font-bold text-sm">재고 상세정보</p>
        <button
          onClick={handleBack}
          className="text-title-black px-5 rounded-[4px] py-1.5 border border-title-black"
        >
          목록
        </button>
      </div>
      <ProductInfo productData={productData} title={"상품정보"} margin="mt-4" />
      <TableInformation
        prodId={id}
        disabledButton={isEmptyStock}
        colorTextButton={isEmptyStock ? "text-disable-black" : "text-black"}
        buttonColor={isEmptyStock ? "bg-disable-grey" : "bg-white"}
        title={"재고정보"}
        margin={"mt-4"}
        productData={productData}
        stockSummaryData={stockSummaryData}
        productLotQntData={productLotQntData}
      />
      <div className="flex gap-4 mt-6 justify-between">
        <div className="w-full">
          <Modal
            padding="px-0 py-2"
            maxWidth="max-w-[62rem]"
            hasCancel={false}
            hasSubmit={false}
            description={
              <DataModal
                prodId={id}
                data={productLotQntData}
                productData={productData}
                setTriggerCloseDataModal={setTriggerCloseDataModal}
                setTriggerCloseDataModalInstruction={
                  setTriggerCloseDataModalInstruction
                }
                triggerCloseDataModalInstruction={
                  triggerCloseDataModalInstruction
                }
              />
            }
            triggerClose={triggerCloseDataModal}
          >
            <Button
              margin={`py-2`}
              width={`w-full`}
              titleButton={`LOT 재고 연동`}
              backgroundColor={`bg-button-blue`}
              textColor={`text-white`}
            />
          </Modal>
        </div>
        <div className="w-full">
          <Modal
            padding="px-0 py-2"
            maxWidth="max-w-[62rem]"
            hasSubmit={false}
            hasCancel={false}
            description={
              <InventoryChangeModal
                currentStockQty={currentStockQty}
                prodId={id}
                productData={productData}
                onCloseModalAdjust={onCloseModalAdjust}
                setTriggerCloseModalAdjust={setTriggerCloseModalAdjust}
              />
            }
            triggerClose={triggerCloseModalAdjust}
          >
            <Button
              margin={`py-2`}
              width={`w-full`}
              disabled={isEmptyStock}
              titleButton={`재고 수동 변경 (조정)`}
              backgroundColor={
                isEmptyStock ? `bg-disable-grey` : `bg-title-red`
              }
              textColor={isEmptyStock ? `text-disable-black` : `text-white`}
            />
          </Modal>
        </div>

        <div className="w-full">
          <Modal
            padding="px-0 py-2"
            maxWidth="max-w-[50rem]"
            hasCancel={false}
            hasSubmit={false}
            description={
              <QRModal
                onCloseModal={onCloseModal}
                setTriggerCloseModal={setTriggerCloseModal}
                currentStockQty={currentStockQty}
                prodId={id}
                productData={productData}
              />
            }
            triggerClose={triggerCloseModal}
          >
            <Button
              margin={`py-2`}
              width={`w-full`}
              disabled={isEmptyStock}
              titleButton={`기타 출고 (QR 스캔)`}
              borderColor={!isEmptyStock && `border-[#777777]`}
              backgroundColor={isEmptyStock ? `bg-disable-grey` : `bg-white`}
              textColor={isEmptyStock ? `text-disable-black` : `text-black`}
            />
          </Modal>
        </div>
      </div>
      <div className="mt-8">
        <p className="text-sm font-bold">재고 상세내역</p>
        <Card
          paddingTopBottom="pt-6 pb-4"
          paddingLeftRight="px-0"
          className={"mt-3"}
        >
          <div className="flex px-6">
            <div className="flex gap-2 mr-[5%] items-center">
              <p className="text-title-black mr-8">검색어</p>
              <Dropdown
                options={options}
                placeholder="기타출고 내역 메모"
                textColor="text-black"
                width="w-40"
                positionDropdown={"top-10"}
                onClickItem={onChangeSearchBy}
              />
              {/* <input
                type="text"
                placeholder="필터 선택 후, 검색"
                className="outline-none py-2 w-52 rounded-[4px] px-2 border h-full"
              /> */}
              <InputSearch
                placeholder="필터 선택 후, 검색"
                onChange={(value) => onChangeSearchByValue(value)}
              />
            </div>
            <div className="flex gap-2 items-center">
              <p className="text-title-black mr-6">기간</p>
              <InputDate
                value={discountStartDate}
                onChange={onChangeDiscountStartDate}
                defaultValue={discountStartDate}
              />
              {" - "}
              <InputDate
                value={discountEndDate}
                onChange={onChangeDiscountEndDate}
                defaultValue={discountEndDate}
              />
              <div
                className={`border h-8 text-center rounded-[4px] border-button-grey flex divide-x text-[#bbbbbb]`}
              >
                <div
                  onClick={() => onChangeDateTo(1)}
                  className={`${
                    selectedDateOption === 1
                      ? "bg-primary-blue rounded-l-[4px] text-white"
                      : ""
                  } py-2 w-[42px] m-auto cursor-pointer text-[10px]`}
                >
                  오늘
                </div>
                <div
                  onClick={() => onChangeDateTo(7)}
                  className={`${
                    selectedDateOption === 7 ? "bg-primary-blue text-white" : ""
                  } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                >
                  7일
                </div>
                <div
                  onClick={() => onChangeDateTo(30)}
                  className={`${
                    selectedDateOption === 30
                      ? "bg-primary-blue text-white"
                      : ""
                  } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                >
                  1개월
                </div>
                <div
                  onClick={() => onChangeDateTo(90)}
                  className={`${
                    selectedDateOption === 90
                      ? "bg-primary-blue rounded-r-[4px] text-white"
                      : ""
                  } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                >
                  3개월
                </div>
              </div>
            </div>
          </div>
          <div className="border-t pt-4 gap-2 mt-4 flex justify-center border-t-disable-grey">
            <Button
              onClick={onSubmitFilter}
              width={`w-28`}
              titleButton={`필터 검색`}
              backgroundColor={`bg-white`}
              borderColor={`border-disable-black`}
              textColor={`text-disable-black`}
              padding={`py-1.5`}
            />
            <Button
              onClick={onResetFilter}
              width={`w-28`}
              borderColor="border-disable-black"
              titleButton={`필터 초기화`}
              backgroundColor={`bg-white`}
              textColor={`text-disable-black`}
            />
          </div>
        </Card>
      </div>
      <div className="flex mt-4 px-6 items-start py-4 bg-input-grey ">
        <div className="flex items-start">
          <p className="mr-12 font-bold">정렬 필터</p>
        </div>
        <div className="">
          <div className="flex">
            <div className="flex">
              {firstRadio.map((item, index) => (
                <div className="flex items-center" key={index}>
                  <input
                    type="radio"
                    className="flex-none mr-1 accent-primary-black"
                    id={item?.label}
                    value={item?.value}
                    name="filterBy"
                    onChange={onSelectRadio}
                  />
                  <label htmlFor={item?.label} className="mr-6">
                    {item.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <div className="flex mt-4">
            {secondRadio.map((item, index) => (
              <div className="flex items-center" key={index}>
                <input
                  type="radio"
                  className="flex-none mr-1 accent-primary-black"
                  id={item?.label}
                  value={item?.value}
                  name="filterBy"
                  onChange={onSelectRadio}
                />
                <label htmlFor={item?.label} className="mr-6">
                  {item.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-6">
        <StockHistoryTable
          isEmptyStock={isEmptyStock}
          isResettedPage={isResettedPage}
          filter={isResetted ? resettedFilter : filters}
          id={id}
        />
      </div>
    </div>
  );
};

export default InventoryDetailPage;
